import React, { useContext, useEffect, useState, useRef } from 'react';
import DashboardHeader from '../../Components/DashboardHeader/DashboardHeader';
import Sidebar from '../../Components/Sidebar/Sidebar';
import { Button, CircularProgress } from '@mui/material';
import cross from '../../Assets/Images/cross.svg';
import greentick from '../../Assets/Images/green-tick.svg';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AuthContext from '../../Context/AuthContext';
import { createClientDeployment, fetchDeployments, sendNotifications } from '../../api';
import EditIcon from '../../Assets/Images/editicon2.svg'
import Notification from '../../Components/Dashboard/Notification/Notification';
import Select from 'react-select';
import { validateName } from '../../utils/helper';

const Clients = () => {
  const authCtx = useContext(AuthContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [clients, setClients] = useState(() => {
    return location.state?.client || JSON.parse(localStorage.getItem("clientData"));
  });


  const navigate = useNavigate();
  const [tab, setTab] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formEdit, setFormEdit] = useState(false)
  const [showMessage, setShowMessage] = useState(false);
  const [showUpateMessage, setShowUpateMessage] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [existingEmails, setExistingEmails] = useState([]);

  const notificationRef = useRef(null)

  const { id: deploymentID } = useParams();

  useEffect(() => {
    if (searchParams.has("isNew")) {
      setShowMessage(true);
      setShowUpateMessage(false)
    }
    if (searchParams.has("upDate")) {
      setShowUpateMessage(true);
      setShowMessage(false);

    }
  }, [searchParams, setSearchParams]);


  useEffect(() => {
    if (clients) {
      localStorage.setItem("clientData", JSON.stringify(clients));
    }
  }, [clients])


  console.log(clients)
  const [firstNameRecent, setFirstNameRecent] = useState('');
  const [formValues, setFormValues] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    title: '',
    type_text: '',
    company: '',
    industry: '',
    groupID: '',
    type_text: ''
  });

  const [errors, setErrors] = useState({
    firstnameError: '',
    lastnameError: '',
    emailError: '',
    phoneError: '',
    titleError: '',
    typedTitleError: '',
    companyError: '',
    industryError: '',
    groupIDError: ''
  });

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validNameRegex = /^[a-zA-Z\s.''\-]{2,}$/;
  // const validPhoneRegex = /^\d{10}$/;
  const validPhoneRegex = /^[0-9+-]{10}$/;

  const titles = [
    // { label: "Select/Start typing", value: "" },
    { label: "Other", value: "Other" },
    { label: "CEO", value: "CEO" },
    { label: "CFO", value: "CFO" },
    { label: "COO", value: "COO" },
    { label: "Director", value: "Director" },
    { label: "HR/People Manager", value: "HR/People Manager" },
    { label: "Administrator", value: "Administrator" },
    { label: "Team/Department Manager", value: "Team/Department Manager" },
    { label: "Service/Customer Service Manager", value: "Service/Customer Service Manager" },
    { label: "Project Manager", value: "Project Manager" },
    { label: "Supervisor", value: "Supervisor" },
    { label: "Marketing/Sales Consultant", value: "Marketing/Sales Consultant" },
    { label: "Accounting/Finance", value: "Accounting/Finance" },
    { label: "Operations Manager", value: "Operations Manager" },
    { label: "Logistics/Supply Chain Coordinator", value: "Logistics/Supply Chain Coordinator" },
    { label: "Executive Assistant", value: "Executive Assistant" },
    { label: "Nonprofit Leader", value: "Nonprofit Leader" },
    { label: "Pastor/Religious Leader", value: "Pastor/Religious Leader" },
    { label: "Athlete/Coach", value: "Athlete/Coach" },
    { label: "Entrepreneur/Small Business Owner", value: "Entrepreneur/Small Business Owner" },
    { label: "Personal Development Seeker", value: "Personal Development Seeker" },
    { label: "Consultant", value: "Consultant" },
    { label: "Educator/Trainer", value: "Educator/Trainer" },
    { label: "Creative Professional", value: "Creative Professional" },
    { label: "Health/Wellness Professional", value: "Health/Wellness Professional" }
  ];


  const industries = [
    // { label: "Select/Start typing", value: "" },
    { label: "Agriculture", value: "Agriculture" },
    { label: "Automotive", value: "Automotive" },
    { label: "Construction", value: "Construction" },
    { label: "Education/Training", value: "Education/Training" },
    { label: "Energy/Utilities", value: "Energy/Utilities" },
    { label: "Engineering", value: "Engineering" },
    { label: "Entertainment/Media", value: "Entertainment/Media" },
    { label: "Finance/Banking", value: "Finance/Banking" },
    { label: "Government/Public Services", value: "Government/Public Services" },
    { label: "Healthcare/Medical", value: "Healthcare/Medical" },
    { label: "Hospitality/Tourism", value: "Hospitality/Tourism" },
    { label: "Information Technology (IT)", value: "Information Technology (IT)" },
    { label: "Insurance", value: "Insurance" },
    { label: "Leadership Development/Consulting", value: "Leadership Development/Consulting" },
    { label: "Legal Services", value: "Legal Services" },
    { label: "Manufacturing/Production", value: "Manufacturing/Production" },
    { label: "Marketing/Advertising", value: "Marketing/Advertising" },
    { label: "Non-Profit/Charity/Churches", value: "Non-Profit/Charity/Churches" },
    { label: "Real Estate/Property", value: "Real Estate/Property" },
    { label: "Transportation/Logistics", value: "Transportation/Logistics" }
  ];

  const customStyles = {
    border: 'none',
    control: (base, state) => ({
      ...base,
      height: 50,
      minHeight: 50,
      width: '97%',
      borderColor: state.isFocused ? '#5795B2' : base.borderColor,
      boxShadow: state.isFocused ? '0 0 0 1px #5795B2' : base.boxShadow,
      '&:hover': {
        borderColor: state.isFocused ? '#5795B2' : base.borderColor,
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '48px',
      padding: '0 15px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
      height: '48px',
    }),
    placeholder: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif',
      color: '#C7C7C7',
      fontSize: 18,
      lineHeight: '21.6px',
      fontWeight: 400,
    }),
    singleValue: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif',
      color: '#303030',
      fontSize: 18,
      lineHeight: '21.6px',
      fontWeight: 400,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    // dropdownIndicator: () => ({
    //   display: 'none',
    // }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '8px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: '10px',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? '#426B88'
        : state.isFocused
          ? '#DDEAF0'
          : 'white',
      color: state.isSelected ? 'white' : '#303030',
      fontFamily: 'Lato, sans-serif',
      fontSize: 16,
      cursor: 'pointer',
    }),
  };


  const extractNumber = (number) => number?.replace(/\D/g, "");

  const formatPhoneNumber = (value) => {
    let cleaned = value.replace(/\D/g, "");
    let formatted = "";

    if (cleaned.length > 6) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    } else if (cleaned.length > 3) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else if (cleaned.length > 0) {
      formatted = `(${cleaned}`;
    }

    return formatted;
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };

    if (isNotificationOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isNotificationOpen]);

  useEffect(() => {
  if (formValues.title === 'Other' && formValues.type_text.trim() === '') {
    setFormValues(prev => ({
      ...prev,
      title: ''
    }));
  }
}, [formValues.type_text]);

  useEffect(() => {
    const fetchExistingClients = async () => {
      try {
        const clients = await fetchDeployments(authCtx);
        const emails = clients.map(client => {
          const emailProp = client?.email;
          return emailProp
        }).filter(Boolean);
        setExistingEmails(emails);
      } catch (error) {
        // console.error("Failed to fetch existing clients:", error);
      }
    };

    fetchExistingClients();
  }, []);


  const handleNotificationOpen = () => {
    setIsNotificationOpen(true);
  }
  const handleNotificationClose = () => {
    setIsNotificationOpen(false);
  };

  const handleSelectChange = (selectedOption, fieldName) => {
    const value = selectedOption?.value || '';

    setFormValues((prev) => ({
      ...prev,
      [fieldName]: value,
    }));

    if (fieldName === 'title') {
      setErrors((prev) => ({
        ...prev,
        titleError: value.trim() === '' ? 'Please enter your job title.' : '',
      }));
    }
    if (fieldName === 'industry') {
      setErrors((prev) => ({
        ...prev,
        titleError: value.trim() === '' ? 'Please enter your industry.' : '',
      }));
    }
  };


  const handleChange = (event) => {
    const { name, value } = event.target;

    // console.log("name,value", name, value)
    if (name === 'phone') {
      setFormValues({ ...formValues, [name]: formatPhoneNumber(value) });
    }
    else {
      setFormValues({ ...formValues, [name]: value });
    }

    // Validation cases
    switch (name) {
      case 'firstname':
        if (!value.trim()) {
          setErrors(prev => ({ ...prev, firstnameError: 'Please enter a valid first name.' }));
        } else {
          const firstNameError = validateName(value);
          if (firstNameError && firstNameError !== 'Please enter a valid name.') {
            setErrors(prev => ({ ...prev, firstnameError: firstNameError }));
          } else if (!validNameRegex.test(value)) {
            setErrors(prev => ({ ...prev, firstnameError: 'Please enter a valid first name.' }));
          } else {
            setErrors(prev => ({ ...prev, firstnameError: '' }));
          }
        }
        break;
      case 'lastname':
        if (!value.trim()) {
          setErrors(prev => ({ ...prev, lastnameError: 'Please enter a valid last name.' }));
        } else {
          const lastNameError = validateName(value);
          if (lastNameError && lastNameError !== 'Please enter a valid name.') {
            setErrors(prev => ({ ...prev, lastnameError: lastNameError }));
          } else if (!validNameRegex.test(value)) {
            setErrors(prev => ({ ...prev, lastnameError: 'Please enter a valid last name.' }));
          } else {
            setErrors(prev => ({ ...prev, lastnameError: '' }));
          }
        }
        break;
      case 'email':
        setErrors(prev => ({ ...prev, emailError: !emailRegex.test(value) ? 'Please enter a valid email address.' : '' }));
        break;
      case 'phone':
        setErrors(prev => ({ ...prev, phoneError: !validPhoneRegex.test(extractNumber(value)) ? 'Please enter a valid phone number.' : '' }));
        break;
      case 'title':
        setErrors(prev => ({ ...prev, titleError: value.trim() === '' ? 'Please select/enter your title.' : '' }));
        break;
      case 'type_text':
        setErrors(prev => ({ ...prev, typedTitleError: value.trim() === '' ? 'Please enter your title.' : '' }));
        break;
      case 'company':
        setErrors(prev => ({ ...prev, companyError: value.trim() === '' ? 'Please enter your company name.' : '' }));
        break;
      case 'industry':
        setErrors(prev => ({ ...prev, industryError: value.trim() === '' ? 'Please select/enter your industry.' : '' }));
        break;
      case 'groupID':
        // No error for empty group ID since it's optional
        setErrors(prev => ({ ...prev, groupIDError: '' }));
        break;
      default:
        break;
    }
  };

  const clientData = JSON.parse(localStorage.getItem("clientData"));

  const sendNotificationsHelper = async (response) => {
    // console.log("data response", response)
    await sendNotifications({
      action: "client_added",
      action_link: `/clients/${response.deploymentId}`,
      msg: "<Full Name> All assessments completed!",
      user_name: formValues?.firstname + " " + formValues?.lastname,
      type: "client_added",
      orgId: authCtx?.orgId,
      clientId: response?.deploymentId,
      asmtId: clientData?.id
    });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (existingEmails.includes(formValues.email.toLowerCase())) {
      setErrors(prev => ({ ...prev, emailError: 'This email is already used by another client.' }));
      return;
    }

    if (validateForm()) {
      setIsLoading(true)
      const data = {
        title: formValues?.title == "Other" ? formValues?.type_text : formValues?.title,
        properties: [
          { property: "email", value: formValues?.email },
          { property: "name", value: formValues?.firstname + " " + formValues?.lastname },
          { property: "firstName", value: formValues?.firstname },
          { property: "lastName", value: formValues?.lastname },
          { property: "industry", value: formValues?.industry },
          { property: "phone", value: extractNumber(formValues?.phone) },
          { property: "company", value: formValues?.company },
          { property: "groupid", value: formValues?.groupID },
          { property: "url", value: formValues?.url || "" },
          { property: "started", value: formValues?.started || new Date() }
        ]
      };

      const { title, properties } = data;

      const requestBody = {
        assessmentId: 78,
        title,
        properties
      };

      const orgId = authCtx?.orgId || localStorage.getItem('orgId');
      if (!formEdit) {
        const response = await createClientDeployment(requestBody, authCtx);
        setIsLoading(false);
        console.log('Client added successfully:', response);
        sendNotificationsHelper(response)
        fetchDeployments(authCtx)
          .then(updatedClientData => {
            const newlyCreatedClient = updatedClientData.find(client => client.id === response.deploymentId);
            console.log("Newly created client:", newlyCreatedClient);
            setFormValues({})
            setClients(newlyCreatedClient)
            navigate(`/added-client/${response.deploymentId}?isNew=true`, {
              state: { client: newlyCreatedClient || response }
            });
            setTab(false)
          })
          .catch(error => {
            console.error('Error fetching updated deployments:', error);
          });

      } else {
        if (deploymentID) {
          const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/${orgId}/deployments/${deploymentID}`;

          fetch(apiUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'mode': 'no-cors',
              'Authorization': `${authCtx.token}`,
            },
            body: JSON.stringify(requestBody),
          })
            .then(response => response.json())
            .then(data => {
              if (data.status === "success") {
                setIsLoading(false);
                console.log('Client added successfully:', data);
                fetchDeployments(authCtx)
                  .then(updatedClientData => {
                    const newlyCreatedClient = updatedClientData.find(client => client?.id == deploymentID);
                    console.log("Newly created client:", newlyCreatedClient);
                    setFormValues({})
                    setClients(newlyCreatedClient)
                    navigate(`/added-client/${deploymentID}?upDate=true`, {
                      state: { client: newlyCreatedClient },
                      replace: true
                    });
                    setTab(false)
                    setFormEdit(false)
                  })
                  .catch(error => {
                    console.error('Error fetching updated deployments:', error);
                  });
              } else {
                setIsLoading(false);
                console.error('Error adding client:', data);
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
        }
      }

    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!validNameRegex.test(formValues.firstname) || formValues.firstname.trim() === '') {
      newErrors.firstnameError = 'Please enter a valid first name.';
      valid = false;
    } else {
      const firstNameError = validateName(formValues.firstname);
      if (firstNameError && firstNameError !== 'Please enter a valid name.') {
        newErrors.firstnameError = firstNameError;
        valid = false;
      }
    }
    
    if (!validNameRegex.test(formValues.lastname) || formValues.lastname.trim() === '') {
      newErrors.lastnameError = 'Please enter a valid last name.';
      valid = false;
    } else {
      const lastNameError = validateName(formValues.lastname);
      if (lastNameError && lastNameError !== 'Please enter a valid name.') {
        newErrors.lastnameError = lastNameError;
        valid = false;
      }
    }
    if (!emailRegex.test(formValues.email)) {
      newErrors.emailError = 'Please enter a valid email address.';
      valid = false;
    }
    if (!validPhoneRegex.test(extractNumber(formValues.phone))) {
      newErrors.phoneError = 'Please enter a valid phone number.';
      valid = false;
    }
    if (formValues.title.trim() === '') {
      newErrors.titleError = 'Please select/enter your title.';
      valid = false;
    } else if (formValues.title === 'Other' && formValues.type_text.trim() === '') {
      newErrors.typedTitleError = 'Please enter your title.';
      valid = false;
    }

    if (formValues.company.trim() === '') {
      newErrors.companyError = 'Please enter your company name.';
      valid = false;
    }
    if (formValues.industry.trim() === '') {
      newErrors.industryError = 'Please select/enter your industry.';
      valid = false;
    }
    // Group ID is optional, no validation needed

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormEdit = () => {
    let first = '';
    let last = '';

    if (clients?.firstName && clients?.lastName) {
      first = clients.firstName;
      last = clients.lastName;
    } else if (clients?.name) {
      const nameParts = clients.name.trim().split(" ");
      first = nameParts[0] || '';
      last = nameParts.slice(1).join(" ") || '';
    }

    setFormValues({
      firstname: first,
      lastname: last,
      email: clients?.email || '',
      phone: clients?.phone || '',
      title: clients?.title || '',
      type_text: clients?.title || '',
      company: clients?.company || '',
      industry: clients?.industry || '',
      groupID: clients?.groupid || '',
    });
    setTab(false)
    setFormEdit(true)
  }

  const resetForm = () => {
    setFormValues({
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      title: '',
      type_text: '',
      company: '',
      industry: '',
      groupID: '',
    });
    setErrors({
      firstnameError: '',
      lastnameError: '',
      emailError: '',
      phoneError: '',
      titleError: '',
      companyError: '',
      industryError: '',
      groupIDError: ''
    });
    setFormEdit(false);
  };

  console.log("formValues", formValues)
  return (
    <div className='dashboard-platform'>
      <DashboardHeader heading='Clients' handleNotificationOpen={handleNotificationOpen} />
      <Notification ref={notificationRef} handleNotificationClose={handleNotificationClose} isNotificationOpen={isNotificationOpen} />
      <div className='dashboard-container'>
        <p className='page-name'>
          <span className='clients' onClick={() => navigate('/clients')}>Clients &gt; </span>
          <span className='create'>{searchParams.has("isNew") ? clients?.name : "Create"}</span>
        </p>
        {
          clients?.id &&
          <div className='client-detail-info' >
            {!formEdit ?
              <>
                <div className="row-one">
                  <div className="name-info-client">
                    <p className='info-client-head'>Name</p>
                    <p className='info-client-body text-capital'>{clients?.name || clients.title}</p>
                  </div>
                  <div className="name-info-client">
                    <p className='info-client-head'>Email</p>
                    <p className='info-client-body'>{clients?.email}</p>
                  </div>
                  <div className="name-info-client">
                    <p className='info-client-head'>Phone</p>
                    <p className='info-client-body'>{formatPhoneNumber(clients?.phone)}</p>
                  </div>
                </div>
                <div className="row-two">
                  <div className="name-info-client">
                    <p className='info-client-head'>Title</p>
                    <p className='info-client-body text-capital'>{clients.title}</p>
                  </div>
                  <div className="name-info-client">
                    <p className='info-client-head'>Company Name</p>
                    <p className='info-client-body text-capital'>{clients.company}</p>
                  </div>

                  <div className="name-info-client">
                    <p className='info-client-head'>Industry</p>
                    <p className='info-client-body text-capital'>{clients.industry}</p>
                  </div>
                </div>
                <div className="row-three">
                  <Button className='view-more-detail' onClick={() => {
                    //Replace with ID when data comes from API
                    setShowMessage(false)
                    navigate(`/client/${clients?.id}?tab=1`, { state: { client: clients } })
                  }}>
                    Visit Profile
                  </Button>
                </div>
                <div className="editbtn" onClick={handleFormEdit}>
                  <img src={EditIcon} alt="" />
                </div>
              </>
              :
              <form className="client-form" onSubmit={handleSubmit} >
                <div className="edit-form">
                  <div className="form-col-one">
                    <div className={`client-info ${errors.firstnameError ? 'error' : ''}`}>
                      <p className='client-info-p'>First Name<span className="asterisk-mark">*</span></p>
                      <input type="text" name="firstname" className='client-input' placeholder='e.g. Simon ' value={formValues.firstname} onChange={handleChange} required />
                      {errors.firstnameError && <div className="form-error">{errors.firstnameError}</div>}
                    </div>
                    <div className={`client-info ${errors.emailError ? 'error' : ''}`}>
                      <p className='client-info-p'>Email<span className="asterisk-mark">*</span></p>
                      <input type="email" name='email' className='client-input' placeholder='e.g. simonpeter@petra.org' value={formValues.email} onChange={handleChange} required />
                      {errors.emailError && <div className="form-error">{errors.emailError}</div>}
                    </div>
                    <div className={`client-info ${errors.titleError ? 'error' : ''}`}>
                      <p className='client-info-p'>Title<span className="asterisk-mark">*</span></p>
                      {
                        formValues.type_text?.length > 0 || formValues.title === "Other" ? <>
                          <div className='title-type-text'>
                            <input type="text" name="type_text" className='client-input' placeholder='Start typing' value={formValues.type_text} onChange={handleChange} required />
                            <Button className='close-btn-typed-text' onClick={() => { setFormValues({ ...formValues, "type_text": "", "title": "" }) }}>
                              <img src={cross} alt="cross" className='cross-image' />
                            </Button>
                          </div>
                          {errors.titleError && <div className="form-error">{errors.titleError}</div>}
                        </>
                          :
                          <>
                            <Select name="title" placeholder={"Select/type your title"} value={titles.find(option => option.value === formValues.title)} onChange={(selectedOption) => handleSelectChange(selectedOption, 'title')} required styles={customStyles} options={titles} >
                              {/* 
                                  {titles.map((title) => (
                                    <option key={title.value} value={title.value} className="client-input">
                                      {title.label}
                                    </option>
                                  ))} 
                                */}
                            </Select>
                            {errors.titleError && <div className="form-error">{errors.titleError}</div>}
                          </>
                      }
                      {/* <input type="text" name="title" className='client-input' placeholder='Select your title' value={formValues.title} onChange={handleChange} required /> */}
                      {/* {errors.titleError && <div className="form-error">{errors.titleError}</div>} */}
                    </div>
                    <div className={`client-info ${errors.industryError ? 'error' : ''}`}>
                      <p className='client-info-p'>Industry<span className="asterisk-mark">*</span></p>
                      <Select name="industry" placeholder={"Select your industry"} value={industries.find(option => option.value === formValues.industry)} onChange={(selectedOption) => handleSelectChange(selectedOption, 'industry')} required styles={customStyles} options={industries} >
                        {/* {industries.map((industry) => (
                          <option key={industry.value} value={industry.value} className="client-input">
                            {industry.label}
                          </option>
                        ))} */}
                      </Select>
                      {/* <input type="text" name="industry" className='client-input' placeholder='Select your industry' value={formValues.industry} onChange={handleChange} required /> */}
                      {errors.industryError && <div className="form-error">{errors.industryError}</div>}
                    </div>

                  </div>
                  <div className="form-col-two">
                    <div className={`client-info ${errors.lastnameError ? 'error' : ''}`}>
                      <p className='client-info-p'>Last Name<span className="asterisk-mark">*</span></p>
                      <input type="text" name="lastname" className='client-input' placeholder='e.g. Peter' value={formValues.lastname} onChange={handleChange} required />
                      {errors.lastnameError && <div className="form-error">{errors.lastnameError}</div>}
                    </div>
                    <div className={`client-info ${errors.phoneError ? 'error' : ''}`}>
                      <p className='client-info-p'>Phone<span className="asterisk-mark">*</span></p>
                      <input type="text" name="phone" className='client-input' placeholder='e.g. (555) 123-4567' value={formValues.phone} onChange={handleChange} required />
                      {errors.phoneError && <div className="form-error">{errors.phoneError}</div>}
                    </div>
                    <div className={`client-info ${errors.companyError ? 'error' : ''}`}>
                      <p className='client-info-p'>Company<span className="asterisk-mark">*</span></p>
                      <input type="text" name="company" className='client-input' placeholder='Type your company’s name' value={formValues.company} onChange={handleChange} required />
                      {errors.companyError && <div className="form-error">{errors.companyError}</div>}
                    </div>
                    <div className={`client-info ${errors.groupIDError ? 'error' : ''}`}>
                      <p className='client-info-p'>Group ID</p>
                      { /* <select name="groupID" className='client-input' placeholder='Select your Group ID' value={formValues.groupID} onChange={handleChange} required style={{ width: '98%' }} >
                          {groupIDs.map((group) => (
                            <option key={group.value} value={group.value} className="client-input">
                              {group.label}
                              </option>
                              ))}
                          </select> */}
                      <input type="text" name="groupID" className='client-input' placeholder='e.g. Simon123 (optional)' value={formValues.groupID} onChange={handleChange} />
                      {errors.groupIDError && <div className="form-error">{errors.groupIDError}</div>}
                    </div>
                  </div>
                </div>
                <div className='client-cta'>
                  {isLoading ? <Button className='client-button' disabled >{<CircularProgress size={20} style={{ color: "#fff" }} />}</Button> : <Button className='client-button' type="submit" onClick={handleSubmit}>Save Changes</Button>}
                </div>
              </form>
            }
          </div>
        }

        {tab ? (
          <div className="client-detail">
            <div className="cross">
              <img src={cross} alt="cross" className='cross-image' onClick={() => { setTab(false) }} />
            </div>
            <h2 className='client-heading'>Fill in these details to add a client </h2>
            <form className="client-form" onSubmit={handleSubmit} >
              <div className="form-col-one">
                <div className={`client-info ${errors.firstnameError ? 'error' : ''}`}>
                  <p className='client-info-p'>First Name<span className="asterisk-mark">*</span></p>
                  <input type="text" name="firstname" className='client-input' placeholder='e.g. Simon' value={formValues.firstname} onChange={handleChange} required />
                  {errors.firstnameError && <div className="form-error">{errors.firstnameError}</div>}
                </div>
                <div className={`client-info ${errors.emailError ? 'error' : ''}`}>
                  <p className='client-info-p'>Email<span className="asterisk-mark">*</span></p>
                  <input type="email" name='email' className='client-input' placeholder='e.g. simonpeter@petra.org' value={formValues.email} onChange={handleChange} required />
                  {errors.emailError && <div className="form-error">{errors.emailError}</div>}
                </div>
                <div className={`client-info ${errors.titleError ? 'error' : ''}`}>
                  <p className='client-info-p'>Title<span className="asterisk-mark">*</span></p>
                  {
                    formValues.title === "Other" ? <>
                      <div className='title-type-text'>
                        <input type="text" name="type_text" className='client-input' placeholder='Start typing' value={formValues.type_text} onChange={handleChange} required />
                        <Button className='close-btn-typed-text' onClick={() => { setFormValues({ ...formValues, "title": "" }) }}>
                          <img src={cross} alt="cross" className='cross-image' />
                        </Button>
                      </div>
                      {errors.typedTitleError && <div className="form-error">{errors.typedTitleError}</div>}
                    </>
                      :
                      <Select name="title" placeholder={"Select/type your title"} value={titles.find(option => option.value === formValues.title)} onChange={(selectedOption) => handleSelectChange(selectedOption, 'title')} required styles={customStyles} options={titles} >
                        {/* {titles.map((title) => (
                    <option key={title.value} value={title.value} className="client-input">
                      {title.label}
                    </option>
                  ))} */}
                      </Select>
                  }
                  {/* <input type="text" name="title" className='client-input' placeholder='Select your title' value={formValues.title} onChange={handleChange} required /> */}
                  {errors.titleError && <div className="form-error">{errors.titleError}</div>}
                </div>
                <div className={`client-info ${errors.industryError ? 'error' : ''}`}>
                  <p className='client-info-p'>Industry<span className="asterisk-mark">*</span></p>
                  <Select name="industry" placeholder={"Select your industry"} value={industries.find(option => option.value === formValues.industry)} onChange={(selectedOption) => handleSelectChange(selectedOption, 'industry')} required styles={customStyles} options={industries} >
                    {/* {industries.map((industry) => (
                      <option key={industry.value} value={industry.value} className="client-input">
                        {industry.label}
                      </option>
                    ))} */}
                  </Select>
                  {/* <input type="text" name="industry" className='client-input' placeholder='Select your industry' value={formValues.industry} onChange={handleChange} required /> */}
                  {errors.industryError && <div className="form-error">{errors.industryError}</div>}
                </div>

              </div>
              <div className="form-col-two">
                <div className={`client-info ${errors.lastnameError ? 'error' : ''}`}>
                  <p className='client-info-p'>Last Name<span className="asterisk-mark">*</span></p>
                  <input type="text" name="lastname" className='client-input' placeholder='e.g. Petra' value={formValues.lastname} onChange={handleChange} required />
                  {errors.lastnameError && <div className="form-error">{errors.lastnameError}</div>}
                </div>
                <div className={`client-info ${errors.phoneError ? 'error' : ''}`}>
                  <p className='client-info-p'>Phone<span className="asterisk-mark">*</span></p>
                  <input type="text" name="phone" className='client-input' placeholder='e.g. (555) 123-4567' value={formValues.phone} onChange={handleChange} required />
                  {errors.phoneError && <div className="form-error">{errors.phoneError}</div>}
                </div>
                <div className={`client-info ${errors.companyError ? 'error' : ''}`}>
                  <p className='client-info-p'>Company<span className="asterisk-mark">*</span></p>
                  <input type="text" name="company" className='client-input' placeholder='Type your company name' value={formValues.company} onChange={handleChange} required />
                  {errors.companyError && <div className="form-error">{errors.companyError}</div>}
                </div>
                <div className={`client-info ${errors.groupIDError ? 'error' : ''}`}>
                  <p className='client-info-p'>Group ID<span className="asterisk-mark"></span></p>
                  {/* <select name="groupID" className='client-input' placeholder='Select your Group ID' value={formValues.groupID} onChange={handleChange} required style={{ width: '98%' }} >
                          {groupIDs.map((group) => (
                            <option key={group.value} value={group.value} className="client-input">
                              {group.label}
                            </option>
                          ))}
                        </select> */}
                  <input type="text" name="groupID" className='client-input' placeholder='e.g. Simon123' value={formValues.groupID} onChange={handleChange} required />
                  {errors.groupIDError && <div className="form-error">{errors.groupIDError}</div>}
                </div>
              </div>
            </form>
            <div className='client-cta'>
              {isLoading ? <Button className='client-button' disabled >{<CircularProgress size={20} style={{ color: "#fff" }} />}</Button> : <Button className='client-button' type="submit" onClick={handleSubmit}>Add a Client</Button>}
            </div>
          </div>
        ) : (
          !formEdit && <div>
            {showMessage && <div className='client-add'>
              <img className='client-add-img' src={greentick} alt="" />
              <p>&nbsp;You have successfully added {clients?.name || 'a client'} as a client.</p>
            </div>
            }
            {showUpateMessage && <div className='client-add'>
              <img className='client-add-img' src={greentick} alt="" />
              <p>&nbsp;You have successfully updated {clients?.name ? clients.name.replace(/\b\w/g, char => char.toUpperCase()) : 'a client'}'s details.</p>
            </div>
            }
            <div className="addmoreclient">
              <Button className='addmoreclient-cta' onClick={() => {
                resetForm();
                setTab(true);
              }}>+ Add another client
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Clients;
